export default __webpack_public_path__ + "static/media/marcos.757f48fb.png";